module.exports = "<svg id=\"i-menu\" viewBox=\"0 0 32 32\" width=\"32\" height=\"32\" fill=\"none\" stroke=\"currentcolor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"6.25%\">\n  <path d=\"M4 8 L28 8 M4 16 L28 16 M4 24 L28 24\" />\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/svg/menu.svg
// module id = 78
// module chunks = 0